import { AgGrid, Grid } from "@jsq/ds/core";
import { useAgGridDefaults } from "~/pages/UserAndRoles/utils/gridConfig";
import { WorkspaceData } from "../../types";
import { useSelectRows, WorkspacesTableContext } from "./hooks/useSelectRows";
import { useWorkspacesTableAgGridOptions } from "./hooks/useWorkspaceTableConfig";

interface WorkspaceTableProps {
  gridApi: AgGrid.GridApi | null;
  onGridReady: (event: AgGrid.GridReadyEvent<WorkspaceData>) => void;
  rowData: WorkspaceData[];
  onSortChanged: () => void;
  onRowClicked: (event: AgGrid.RowClickedEvent<WorkspaceData>) => void;
  onFilterChanged: (event: AgGrid.FilterChangedEvent) => void;
}

export const WorkspaceTable = ({
  gridApi,
  onGridReady,
  onRowClicked,
  onSortChanged,
  rowData,
  onFilterChanged,
}: WorkspaceTableProps) => {
  const { colDefs } = useWorkspacesTableAgGridOptions();
  const { gridOptions } = useAgGridDefaults({
    overrides: {
      paginationPageSize: 50,
      pagination: true,
      overlayNoRowsTemplate: "No workspaces found",
      rowSelection: "multiple",
    },
  });
  const { onSelectionChanged, sideBar, selectedRows } = useSelectRows<WorkspaceData>({
    gridApi,
  });

  return (
    <WorkspacesTableContext.Provider value={{ selectedRows }}>
      <Grid
        data-testid="workspace-grid"
        onGridReady={onGridReady}
        columnDefs={colDefs}
        rowData={rowData}
        gridOptions={gridOptions}
        onSortChanged={onSortChanged}
        onSelectionChanged={onSelectionChanged}
        onRowClicked={onRowClicked}
        onFilterChanged={onFilterChanged}
        sideBar={sideBar}
      />
    </WorkspacesTableContext.Provider>
  );
};
